<template>
  <div class="d-flex flex-column justify-center align-center">
        <v-card class="mt-2" max-width='500px' width='97%'>

            <v-card-text> <span>{{$t("integrations.config_access")}}:</span> </v-card-text>

            <v-card-text>

                <v-text-field class="ozmap-api" :disabled='integrated' persistent-hint :hint='$t("integrations.ozmapAPIkeyHint")' v-model="ozmapAPIkey" :label="$t('integrations.ozmapAPIkey')" outlined> </v-text-field>

                <v-text-field class="ozmap-url" :disabled='integrated' v-model="ozmapUrl" :label="$t('integrations.ozmapURL')" outlined> </v-text-field>

            </v-card-text> 

        </v-card>

        <v-card class="mt-2" max-width='500px' width='97%' height='100%'>

            <v-card-text> <span>{{$t("integrations.integration_options")}}:</span> </v-card-text>

            <v-card-text>

                <v-text-field class="ozmap-radius" persistent-hint :hint='$t("integrations.ozmapRadiusHint")' type="number" v-model="options.areaRadius" :label="$t('integrations.ozmapRadius')" outlined> </v-text-field>

            </v-card-text>

            <!-- Botões -->

            <v-card-actions class="d-flex justify-center mt-n3">

                <v-row>

                    <v-col class="d-flex flex-column justify-center">
                        <v-btn @click="clickUpdate" class="mb-3" :disabled='!ozmapAPIkey || !ozmapUrl ' :loading='loading' color='primary'>
                            <span >{{$t('integrations.update_integration')}}</span>
                        </v-btn>
                    </v-col>
                    <v-col class="d-flex flex-column justify-center" >
                        <v-btn  @click="clickDelete" class="mb-3" :disabled='!ozmapAPIkey || !ozmapUrl ' :loading='loading' color='error'>
                            <span >{{$t('integrations.delete_integration')}}</span>
                        </v-btn>
                    </v-col>

                </v-row>

            </v-card-actions>

        </v-card>

        <!-- Modal Escolha -->

        <v-dialog v-if="dialog" v-model="dialog" hide-overlay transition="dialog-bottom-transition" max-width='300px'>

            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('provider_dashboard.config')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-list three-line>
                    <v-list-item>
                        <v-list-item-action>
                            <v-btn fab color='success'  @click="confirmAction()">
                                <v-icon>mdi-check</v-icon>
                            </v-btn>
                        </v-list-item-action>
                        <v-list-item-content>

                            <v-list-item-title>{{$t('integrations.confirm_action')}}</v-list-item-title>

                        </v-list-item-content>
                    </v-list-item>
                  
                </v-list>
            </v-card>
        </v-dialog>

  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { DELETE_INTEGRATION, UPDATE_INTEGRATION } from '../../../store/mutations'
import dayjs from 'dayjs';

export default {
    name: 'OzmapIntegrationCard',
    data() {
        return {
            ozmapAPIkey: '',
            ozmapUrl: '',
            options: {
                areaRadius: 100,
                wipeAreas: false,
            }, 
            loading: false,
            integrationData: {},
            integrated: false,
            lastIntegration: '',
            integrationStatus: '',
            dialog: false,
            method: ''
        }
    },

    props: ['integrations'],

    filters: {

        date(date) {

            return dayjs(date).format('DD/MM/YYYY hh:mm:ss')

        },


    },

    computed: {

    },

    mounted() {

        if (!this.integrations) return

        this.integrationData = this.integrations

        this.populateFields()
        
    },

    methods: {
      
      ...mapActions({ updateIntegrationVuex: `ProviderVuex/${UPDATE_INTEGRATION}`, deleteIntegrationVuex: `ProviderVuex/${DELETE_INTEGRATION}` }),

      confirmAction() {

          if (this.method === 'update') this.updateIntegration()
          if (this.method === 'delete') this.deleteIntegration()

      },

      clickUpdate() {

          this.method = 'update'
          this.dialog = true

      },

      clickDelete() {

          this.method = 'delete'
          this.dialog = true

      },

      async updateIntegration() {

          const updateData = {

              integration: { integrator: 'ozmap', api_key: this.ozmapAPIkey, url: this.ozmapUrl, options: this.options },
              id: this.integrationData._id

          }

          try {

                await this.updateIntegrationVuex(updateData)

                this.$emit('changedIntegration')

                this.dialog = false

                return this.showToast(this.$t('integrations.updated_msg'), this.$t('integrations.saved_title'), 'info')
             
          } catch (error) {

                console.log(error)            

                return this.showToast(error.message, this.$t('integrations.integrations'), 'error')
              
          }
      },

      async deleteIntegration() {


          try {

                await this.deleteIntegrationVuex({id: this.integrationData._id})

                this.$emit('changedIntegration')

                this.dialog = false

                return this.showToast(this.$t('integrations.deleted_msg'), this.$t('integrations.saved_title'), 'info')
             
          } catch (error) {

                console.log(error)            

                return this.showToast(error.message, this.$t('integrations.integrations'), 'error')
              
          }
      },

      populateFields() {

          this.ozmapAPIkey = this.integrationData.api_key
          this.lastIntegration = this.integrationData.created_at
          this.integrationStatus = this.integrationData.status
          this.ozmapUrl = this.integrationData.url
          this.options.areaRadius = this.integrationData.options.areaRadius
          this.options.wipeAreas = this.integrationData.options.wipeAreass = this.integrationData.options.wipeAreas

          return this.integrated = true

      },


    },

}
</script>
